export default "__VITE_ASSET__89808659__"